(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  href: _propTypes.string,
  info: _propTypes.string,
  text: _propTypes.string.isRequired,
  type: _propTypes.string,
  size: _propTypes.string,
  theme: _propTypes.string,
  outline: _propTypes.bool,
  cssClass: _propTypes.string,
  handleClick: _propTypes.func
};

// ImageCTA is a stateless functional component.
var Button = function Button(props) {
  var href = props.href,
    info = props.info,
    text = props.text,
    _props$type = props.type,
    type = _props$type === void 0 ? "button" : _props$type,
    size = props.size,
    theme = props.theme,
    _props$outline = props.outline,
    outline = _props$outline === void 0 ? false : _props$outline,
    _props$cssClass = props.cssClass,
    cssClass = _props$cssClass === void 0 ? "" : _props$cssClass,
    handleClick = props.handleClick;
  var buttonSize = size ? "hl__button--".concat(size) : "";
  var buttonStyle = outline ? "hl__button--minor" : "";
  var buttonTheme = theme ? "hl__button--".concat(theme) : "";
  var buttonClass = "hl__button ".concat(buttonSize, " ").concat(buttonTheme, " ").concat(buttonStyle, " ").concat(cssClass);
  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      className: buttonClass,
      title: info
    }, text);
  } else {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: type,
      className: buttonClass,
      "aria-label": info,
      onClick: handleClick
    }, text);
  }
};
Button.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = Button;

},{"prop-types":"prop-types","react":"react"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  checked: _propTypes.bool.isRequired,
  icon: _propTypes.string,
  inline: _propTypes.bool,
  label: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  subLabel: _propTypes.string,
  theme: _propTypes.string,
  value: _propTypes.string.isRequired
};
var CheckboxFilter = function CheckboxFilter(props) {
  var handleChange = function handleChange(event) {
    props.onChange(event);
  };
  var name = props.name,
    value = props.value,
    label = props.label,
    _props$subLabel = props.subLabel,
    subLabel = _props$subLabel === void 0 ? "" : _props$subLabel,
    checked = props.checked,
    icon = props.icon,
    inline = props.inline,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? "dark" : _props$theme;
  var inlineClass = inline ? "hl__checkbox-filter--inline" : "";
  var themeClass = theme ? "hl__checkbox-filter--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: "hl__checkbox-filter ".concat(themeClass, " ").concat(inlineClass)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    name: name,
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: handleChange,
    className: "hl__checkbox-filter__label"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__checkbox-filter__container"
  }, icon && !inline && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__icon"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: icon,
    alt: ""
  })), icon && inline && /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: icon,
    className: "hl__checkbox-filter__icon"
  }), subLabel === "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__label"
  }, label), subLabel !== "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__label"
  }, label, " \u2014 ", /*#__PURE__*/_react["default"].createElement("small", null, subLabel))));
};
CheckboxFilter.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = CheckboxFilter;

},{"prop-types":"prop-types","react":"react","react-inlinesvg":"react-inlinesvg"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _checkboxFilter = _interopRequireDefault(require("../../01-atoms/forms/checkbox-filter.jsx"));
var _weekPicker = _interopRequireDefault(require("../../02-molecules/forms/week-picker.jsx"));
var _reactPicky = require("react-picky");
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FilterBarGroup = exports["default"] = /*#__PURE__*/function (_Component) {
  function FilterBarGroup() {
    var _this;
    _classCallCheck(this, FilterBarGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FilterBarGroup, [].concat(args));
    _defineProperty(_this, "handleAccordion", function (e) {
      e.preventDefault();
      _this.props.accordionChange(_this.props.param, !_this.props.expanded);
    });
    _defineProperty(_this, "handleSelectChange", function (value) {
      var _this$props = _this.props,
        param = _this$props.param,
        onChange = _this$props.onChange;
      onChange(param, value);
    });
    return _this;
  }
  _inherits(FilterBarGroup, _Component);
  return _createClass(FilterBarGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.expanded == nextProps.expanded) {
        return;
      }
      var $content = (0, _jquery["default"])(this.accordionContent);
      if (nextProps.expanded) {
        $content.slideDown();
      } else {
        $content.slideUp();
      }
    }
  }, {
    key: "renderFilters",
    value: function renderFilters() {
      var _this$props2 = this.props,
        _this$props2$assetsUr = _this$props2.assetsUrl,
        assetsUrl = _this$props2$assetsUr === void 0 ? "../.." : _this$props2$assetsUr,
        param = _this$props2.param,
        onChange = _this$props2.onChange,
        filterType = _this$props2.filterType,
        _this$props2$selected = _this$props2.selected,
        selected = _this$props2$selected === void 0 ? [] : _this$props2$selected,
        items = _this$props2.items,
        placeholder = _this$props2.placeholder,
        label = _this$props2.label;
      switch (filterType) {
        case "checkbox":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_checkboxFilter["default"], _extends({
              key: param + item.value,
              onChange: onChange,
              name: param
            }, item));
          });
          break;
        case "select":
          return /*#__PURE__*/_react["default"].createElement(_reactPicky.Picky, {
            id: param,
            value: selected,
            name: param,
            options: items,
            multiple: true,
            includeSelectAll: false,
            includeFilter: false,
            onChange: this.handleSelectChange,
            dropdownHeight: 200,
            valueKey: 'value',
            labelKey: 'label',
            numberDisplayed: 0,
            placeholder: placeholder,
            manySelectedPlaceholder: placeholder + " (%s)"
          });
          break;
        case "keyword":
          return /*#__PURE__*/_react["default"].createElement("input", {
            className: "hl__input",
            "aria-label": label,
            name: param,
            id: param,
            type: "search",
            placeholder: placeholder,
            value: items.length && items[0].value ? items[0].value : "",
            onChange: onChange
          });
          break;
        case "weekPicker":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_weekPicker["default"], _extends({
              key: "single_date_".concat(index),
              assetsUrl: assetsUrl,
              onDateChange: onChange
            }, item));
          });
          break;
        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        label = _this$props3.label,
        expanded = _this$props3.expanded,
        filterType = _this$props3.filterType,
        hideAccordion = _this$props3.hideAccordion,
        accordionChange = _this$props3.accordionChange;
      var themeClass = filterType === "inline-checkbox" ? "hl__filter-bar-group--inline" : "";
      return /*#__PURE__*/_react["default"].createElement("fieldset", {
        className: "hl__filter-bar-group ".concat(themeClass)
      }, !hideAccordion && accordionChange && /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "hl__filter-bar-group__label",
        type: "button",
        "aria-expanded": expanded,
        onClick: this.handleAccordion
      }, label)), hideAccordion && /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-group__label"
      }, label)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar-group__items",
        ref: function ref(el) {
          return _this2.accordionContent = el;
        }
      }, this.renderFilters()));
    }
  }]);
}(_react.Component);
_defineProperty(FilterBarGroup, "propTypes", {
  accordionChange: _propTypes.func,
  assetsUrl: _propTypes.string,
  expanded: _propTypes.bool.isRequired,
  filterType: _propTypes.string.isRequired,
  hideAccordion: _propTypes.bool,
  items: _propTypes.array.isRequired,
  label: _propTypes.string,
  onChange: _propTypes.func.isRequired,
  param: _propTypes.string.isRequired,
  placeholder: _propTypes.string,
  selected: _propTypes.array // for select type
});

},{"../../01-atoms/forms/checkbox-filter.jsx":2,"../../02-molecules/forms/week-picker.jsx":5,"jquery":"jquery","prop-types":"prop-types","react":"react","react-picky":"react-picky"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _filterBarGroup = _interopRequireDefault(require("./filter-bar-group.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  message: _propTypes.string,
  groups: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    param: _propTypes.string.isRequired,
    expanded: _propTypes.bool.isRequired,
    items: _propTypes.array
  })).isRequired,
  onClearAll: _propTypes.func,
  title: _propTypes.string.isRequired,
  theme: _propTypes.string
};
var FilterBar = function FilterBar(props) {
  var renderGroups = function renderGroups(groups) {
    var assetsUrl = props.assetsUrl;
    return groups.filter(function (group) {
      return group.items && group.items.length;
    }).map(function (group) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-bar__group",
        key: group.param
      }, /*#__PURE__*/_react["default"].createElement(_filterBarGroup["default"], _extends({
        assetsUrl: assetsUrl
      }, group)));
    });
  };
  var groups = props.groups,
    title = props.title,
    onClearAll = props.onClearAll,
    assetsUrl = props.assetsUrl,
    message = props.message,
    theme = props.theme;
  var themeColor = theme ? "hl__filter-bar--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar ".concat(themeColor)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__container"
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: "hl__filter-bar__header"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__filter-bar__title"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__filters"
  }, renderGroups(groups), message && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__message"
  }, message)), onClearAll && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-bar__clear"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "hl__filter-bar__clear-button",
    type: "button",
    "aria-label": "Clear all filters",
    onClick: onClearAll
  }, "Clear All"))));
};
FilterBar.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = FilterBar;

},{"./filter-bar-group.jsx":3,"prop-types":"prop-types","react":"react"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("react-dates/initialize");
var _reactDates = require("react-dates");
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = require("prop-types");
var _reactMomentProptypes = require("react-moment-proptypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // https://github.com/airbnb/react-dates
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  date: _reactMomentProptypes.momentObj.isRequired,
  focused: _propTypes.bool.isRequired,
  onFocusChange: _propTypes.func.isRequired,
  onDateChange: _propTypes.func.isRequired,
  properties: _propTypes.object,
  // optional settings
  navPrev: _propTypes.node,
  navNext: _propTypes.node
};
var WeekPicker = function WeekPicker(props) {
  var onChange = function onChange(date) {
    if (date.day() !== 0) {
      date.subtract(date.day(), "days");
    }
    props.onDateChange(date);
  };
  var onPreviousWeek = function onPreviousWeek() {
    props.onDateChange(props.date.subtract(7, "days"));
  };
  var onNextWeek = function onNextWeek() {
    props.onDateChange(props.date.add(7, "days"));
  };
  var assetsUrl = props.assetsUrl,
    properties = props.properties,
    focused = props.focused,
    date = props.date,
    onFocusChange = props.onFocusChange;
  var endDate = (0, _moment["default"])(date).add(6, "days").format("MMM DD, YYYY");
  var navPrev = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-733.000000, -834.000000)",
    fill: "#1E1E1E"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(690.000000, 790.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    transform: "translate(47.264520, 51.000000) scale(-1, 1) translate(-47.264520, -51.000000) ",
    points: "44.476406 58 51.2020202 51.0008077 44.476406 44 43.3270202 45.9416176 48.1873394 51.0008077 43.3270202 56.0583824"
  })))));
  var navNext = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-960.000000, -834.000000)",
    fill: "#1E1E1E"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(690.000000, 790.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "271.149386 58 277.875 51.0008077 271.149386 44 270 45.9416176 274.860319 51.0008077 270 56.0583824"
  })))));
  var downArrow = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask0_4901_183512",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "16",
    height: "16"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "16",
    height: "16",
    fill: "#D9D9D9"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    mask: "url(#mask0_4901_183512)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.99967 11.7556L3.33301 7.08889L4.4219 6L7.99967 9.57778L11.5775 6L12.6663 7.08889L7.99967 11.7556Z",
    fill: "#A51C30"
  })));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__date-range"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__control"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: date < (0, _moment["default"])(),
    onClick: onPreviousWeek,
    type: "button",
    "aria-label": "Previous week",
    className: "hl__week-picker__control--previous"
  }, navPrev)), /*#__PURE__*/_react["default"].createElement(_reactDates.SingleDatePicker, _extends({
    date: date,
    focused: focused,
    onFocusChange: onFocusChange,
    onDateChange: onChange,
    navPrev: navPrev,
    navNext: navNext,
    showDefaultInputIcon: true,
    inputIconPosition: "after",
    customInputIcon: downArrow
  }, properties)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__week-picker__to-divider"
  }, "to"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__end-date__group"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__week-picker__end-date"
  }, endDate), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__control"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onNextWeek,
    type: "button",
    "aria-label": "Next week",
    className: "hl__week-picker__control--next"
  }, navNext)))));
};
WeekPicker.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = WeekPicker;

},{"moment":"moment","prop-types":"prop-types","react":"react","react-dates":"react-dates","react-dates/initialize":"react-dates/initialize","react-moment-proptypes":"react-moment-proptypes"}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  title: _propTypes.string.isRequired,
  type: _propTypes.string,
  story_source: _propTypes.string,
  subText: _propTypes.string,
  date: _propTypes.string.isRequired,
  time: _propTypes.string,
  location: _propTypes.string,
  href: _propTypes.string.isRequired,
  href_target: _propTypes.string,
  info: _propTypes.string
};
var NewsTeaser = function NewsTeaser(props) {
  var title = props.title,
    type = props.type,
    story_source = props.story_source,
    story_subject = props.story_subject,
    subText = props.subText,
    date = props.date,
    href = props.href,
    href_target = props.href_target,
    info = props.info;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__image-promo hl__clickable-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__image-promo__details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__image-promo__date--with-source"
  }, date), story_source && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__image-promo__source hl__image-promo__source--with-date"
  }, story_source), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "hl__image-promo__title"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "hl__clickable-card__link",
    href: href,
    target: href_target
  }, title)), subText && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__image-promo__description"
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__rich-text"
  }, subText))));
};
NewsTeaser.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = NewsTeaser;

},{"prop-types":"prop-types","react":"react"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _newsTeaser = _interopRequireDefault(require("../../02-molecules/teasers/news-teaser.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var propTypes = {
  events: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string
  })).isRequired
};
var NewsGrid = function NewsGrid(props) {
  var renderNews = function renderNews(events) {
    return events.map(function (event, i) {
      return /*#__PURE__*/_react["default"].createElement(_newsTeaser["default"], _extends({
        key: event.id + i
      }, event));
    });
  };
  var events = props.events;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__news-grid"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__news-grid__container"
  }, renderNews(events.slice(0, 4)), /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__pattern-cta hl__pattern-cta--full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__pattern-cta__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__pattern-cta__title"
  }, "Give Back"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__pattern-cta__description"
  }, "Giving back to the Harvard Library means you can make a difference for the bright minds of the future."), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__pattern-cta__links"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "hl__button hl__button--small ",
    href: "https://library.harvard.edu/support-library",
    title: "Giving back to the Harvard Library means you can make a difference for the bright minds of the future.",
    "data-ga-link": "Primary CTA Large"
  }, "Give back today")))), renderNews(events.slice(4))));
};
NewsGrid.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = NewsGrid;

},{"../../02-molecules/teasers/news-teaser.jsx":6,"prop-types":"prop-types","react":"react"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _ramda = _interopRequireDefault(require("ramda"));
var _queryString = _interopRequireDefault(require("query-string"));
var _newsGrid = _interopRequireDefault(require("../../03-organisms/lists/news-grid.jsx"));
var _button = _interopRequireDefault(require("../../01-atoms/buttons/button.jsx"));
var _filterBar = _interopRequireDefault(require("../../02-molecules/forms/filter-bar.jsx"));
var _reactSticky = require("react-sticky");
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NewsListingApp = exports["default"] = /*#__PURE__*/function (_Component) {
  function NewsListingApp(props) {
    var _this;
    _classCallCheck(this, NewsListingApp);
    _this = _callSuper(this, NewsListingApp, [props]);
    /********** Data Fetching ***************/
    // returns an array of properly formated filters
    _defineProperty(_this, "fetchLibraries", function () {
      return fetch("".concat(_this.props.requestUrl, "/api/v1/library?_format=json")).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data;
      })["catch"](function (error) {
        console.warn("failed to fetch libraries:", error);
        return [];
      });
    });
    _defineProperty(_this, "fetchResults", function () {
      var loadMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (loadMore) {
        _this.page++;
      } else {
        _this.page = 0;
      }
      var activeFilters = Object.assign({
        page: _this.page,
        _format: "json"
      }, _this.queryString);
      _this.$ajaxResults.abort();
      _this.$ajaxResults = _jquery["default"].ajax({
        url: "".concat(_this.props.requestUrl, "/api/v1/news"),
        // cache: false,
        data: activeFilters
      });
      _this.$ajaxResults.done(function (data) {
        var currentResults = _this.state.results;
        var newResults = {
          totalCount: data.results.totalCount || 0,
          items: []
        };
        if (typeof data.results.items === "undefined" || data.results.items.length === 0) {
          if (!loadMore) {
            _this.setState({
              results: newResults
            });
          }
          return;
        }
        var newItems = _this.parseResultItems(data.results.items);
        if (loadMore) {
          newResults.items = currentResults.items.concat(newItems);
        } else {
          newResults.items = newItems;
        }
        _this.setState({
          results: newResults
        });
      }).fail(function (xhr, status, error) {
        console.warn("failed to fetch results");
        var results = {
          totalCount: 0,
          items: []
        };
        _this.setState({
          results: results
        });
      });
    });
    /********** End Data Fetching ***************/
    /********** Data Manipulation ***************/
    _defineProperty(_this, "parseResultItems", function (data) {
      var filters = _this.state.filters;
      return data.map(function (story, i) {
        if (story.story_type == 'News Mention') {
          var href = story.external_link;
          var href_target = "_blank";
        } else {
          var href = story.url;
          var href_target = "";
        }
        return {
          id: story.id || "".concat(i),
          index: "".concat(i),
          title: story.title,
          type: story.story_type,
          subText: story.summary || "",
          date: story.date,
          href: href,
          href_target: href_target,
          story_author: story.story_author,
          story_subject: story.story_subject,
          story_source: story.story_source,
          info: "See details about \"".concat(story.title, "\"")
        };
      });
    });
    _defineProperty(_this, "initializeFilters", function (filters) {
      var params = _this.queryString;
      if (params.keywords && filters.keywords.items.length) {
        filters.keywords.items[0].value = params.keywords;
      }
      if (params.library_id && filters.library.items.length) {
        if (typeof params.library_id === "string") {
          params.library_id = [params.library_id];
        }
        filters.library.selected = filters.library.items.filter(function (a) {
          return params.library_id.some(function (b) {
            return a.value === b;
          });
        });
      }
      return filters;
    });
    // function takes two optional values
    // the url parameter and the value it should equal
    // if neither a parameter or value are passed,
    // we assume the queryString has been updated elsewhere
    // and we just need to reset the url
    _defineProperty(_this, "updateUrl", function (param) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // if a parameter and a value are passed add the new value
      if (param && value) {
        _this.queryString[param] = value;
      }
      // if a parameter is passed with a value remove the parameter
      if (param && (value === null || value.length === 0)) {
        delete _this.queryString[param];
      }
      var stringifiedQueries = _queryString["default"].stringify(_this.queryString);
      var newUrl = window.location.origin + window.location.pathname + "?" + stringifiedQueries;
      window.history.replaceState({
        path: newUrl
      }, "", newUrl);
    });
    /********** End Data Manipulation ***************/
    /********** Event Handlers ***************/
    // when search terms are changed
    _defineProperty(_this, "handleKeywordChange", function (event) {
      var filters = Object.assign({}, _this.state.filters);
      var value = event.target.value;
      filters.keywords.items[0].value = value;
      _this.updateUrl(filters.keywords.param, value);
      _this.setState({
        filters: filters
      });
      if (value.length > 1 || value.length === 0) {
        // fetch results
        _this.fetchResults();
      }
    });
    _defineProperty(_this, "handleLoadMore", function () {
      _this.fetchResults(true);
    });
    _defineProperty(_this, "onSelectChange", function (filterName, value) {
      var filters = Object.assign({}, _this.state.filters);
      for (var filterObj in filters) {
        if (filterName === filters[filterObj].param) {
          filters[filterObj].selected = value;
          _this.updateUrl(filterName, value.map(function (v) {
            return v.value;
          }));
          break;
        }
      }
      _this.setState({
        filters: filters
      });

      // fetch results
      _this.fetchResults();
    });
    // when the clear all button is clicked
    // receives the event from the button
    _defineProperty(_this, "onClearAll", function (event) {
      event.preventDefault();
      var oldFilters = _this.state.filters;
      var filters = _ramda["default"].map(function (filter) {
        if (filter.selected) {
          filter.selected = [];
        }
        if (filter.filterType === 'checkbox') {
          var _iterator = _createForOfIteratorHelper(filter.items),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              if (item.checked) {
                item.checked = false;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        return filter;
      }, oldFilters);
      filters.keywords.items[0].value = "";

      // clear the parameters in the url
      _this.queryString = {};
      _this.updateUrl();
      _this.fetchResults();
      _this.setState({
        filters: filters
      });
    });
    _this.state = {
      filters: {
        keywords: {
          label: "Search",
          placeholder: "Try 'keyword'",
          param: "keywords",
          expanded: true,
          hideAccordion: true,
          filterType: "keyword",
          onChange: _this.handleKeywordChange,
          items: [{
            value: ""
          }]
        },
        library: {
          label: "Library",
          placeholder: "Library",
          param: "library_id",
          expanded: true,
          hideAccordion: true,
          filterType: "select",
          onChange: _this.onSelectChange,
          selected: [],
          items: []
        }
      },
      results: {
        totalCount: 0,
        items: []
      }
    };
    _this.page = 0;
    _this.$ajaxResults = _jquery["default"].ajax();
    _this.queryString = _queryString["default"].parse(location.search); // params in the url
    _this.emptyMessage = "Loading...";
    _this.keywordDebounce = null;
    return _this;
  }
  _inherits(NewsListingApp, _Component);
  return _createClass(NewsListingApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // fetch all Libraries
      var getLibraries = this.fetchLibraries().then(function (data) {
        var filters = data.map(function (library) {
          return {
            label: library.name,
            value: library.id
          };
        });
        return {
          filters: filters,
          libraries: data
        };
      });
      Promise.all([getLibraries]).then(function (values) {
        var filters = Object.assign({}, _this2.state.filters);
        filters.library.items = filters.library.items.concat(values[0].filters);

        // mark filters found in the URL
        filters = _this2.initializeFilters(filters);

        // update state and render filters
        _this2.setState({
          filters: filters
        });

        // fetch results
        _this2.fetchResults();
        _this2.emptyMessage = "No Results";
      });
    }
  }, {
    key: "render",
    value: /********** End Event Handlers ***************/

    function render() {
      var _this3 = this;
      var assetsUrl = this.props.assetsUrl;
      var _this$state = this.state,
        filters = _this$state.filters,
        results = _this$state.results;
      var button = {
        text: "Load More",
        theme: "secondary"
      };
      var filterArray = [filters.keywords, filters.library];
      return /*#__PURE__*/_react["default"].createElement(_reactSticky.StickyContainer, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-directory__app"
      }, /*#__PURE__*/_react["default"].createElement(_reactSticky.Sticky, null, function (_ref) {
        var style = _ref.style,
          isSticky = _ref.isSticky;
        return /*#__PURE__*/_react["default"].createElement("section", {
          style: _objectSpread({}, style),
          className: "hl__filter-bar-directory__filters",
          "data-sticky": isSticky ? 'sticky' : 'static'
        }, /*#__PURE__*/_react["default"].createElement(_filterBar["default"], {
          onClearAll: _this3.onClearAll,
          assetsUrl: assetsUrl,
          title: "Search",
          groups: filterArray,
          theme: "subtle"
        }));
      }), /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__filter-directory__results"
      }, results.items.length > 0 && /*#__PURE__*/_react["default"].createElement(_newsGrid["default"], {
        events: results.items
      }), results.items.length === 0 && /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__filter-directory__no-results"
      }, this.emptyMessage), results.items && results.items.length < results.totalCount && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-directory__load-more"
      }, /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
        handleClick: this.handleLoadMore
      }, button))))));
    }
  }]);
}(_react.Component);
_defineProperty(NewsListingApp, "propTypes", {
  requestUrl: _propTypes.string.isRequired,
  assetsUrl: _propTypes.string.isRequired
});

},{"../../01-atoms/buttons/button.jsx":1,"../../02-molecules/forms/filter-bar.jsx":4,"../../03-organisms/lists/news-grid.jsx":7,"jquery":"jquery","prop-types":"prop-types","query-string":"query-string","ramda":"ramda","react":"react","react-sticky":"react-sticky"}],9:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _filterListingNewsApp = _interopRequireDefault(require("./filter-listing-news-app.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var el = document.querySelector(".js-news-listing-app");
if (el) {
  var props = {
    requestUrl: el.getAttribute("data-request-url"),
    assetsUrl: el.getAttribute("data-assets-url")
  };
  (0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(_filterListingNewsApp["default"], props), el);
}

},{"./filter-listing-news-app.jsx":8,"react":"react","react-dom":"react-dom"}],10:[function(require,module,exports){
"use strict";

var _filterListingNews = _interopRequireDefault(require("../_patterns/04-templates/base/filter-listing-news.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }

},{"../_patterns/04-templates/base/filter-listing-news.js":9}]},{},[10]);
